'use client';
import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import AppLogo from '@/components/ui/AppLogo';

const navGroups = [
  {
    title: 'Navigasi',
    links: [
      { label: 'Kavling', href: '/kavling' },
      { label: 'Project', href: '/projects' },
      { label: 'Cara Membeli', href: '/cara-membeli' },
      { label: 'Tentang Kami', href: '/tentang-kami' },
      { label: 'Insight', href: '/insight' },
      { label: 'FAQ', href: '/faq' },
    ],
  },
  {
    title: 'Partner',
    links: [
      { label: 'Jadi Partner', href: '/jadi-partner' },
      { label: 'Login Partner', href: '/agent-dashboard' },
      { label: 'Promo', href: '/promo' },
      { label: 'Simulasi', href: '/simulasi' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', href: '/privacy-policy' },
      { label: 'Terms & Conditions', href: '/terms' },
      { label: 'Disclaimer', href: '/disclaimer' },
      { label: 'Legalitas', href: '/legalitas' },
    ],
  },
];

export default function PublicFooter() {
  return (
    <footer className="bg-foreground text-white/80">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 py-14">
        <div className="grid lg:grid-cols-5 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link href="/homepage" className="flex items-center gap-2 mb-4">
              <AppLogo size={36} />
              <span className="font-bold text-xl text-white tracking-tight">
                Betaland<span className="text-accent">.ID</span>
              </span>
            </Link>
            <p className="text-sm text-white/60 leading-relaxed mb-5 max-w-xs">
              Platform properti kavling terpercaya. Legalitas terjamin, proses transparan, lokasi strategis.
            </p>
            <div className="space-y-2 text-sm">
              <a href="https://wa.me/6281282760110" target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/70 hover:text-white transition-colors">
                <Icon name="ChatBubbleLeftRightIcon" size={16} className="text-[#25D366]" />
                +62 812-8276-0110
              </a>
              <a href="mailto:betalandproperty@gmail.com" className="flex items-center gap-2 text-white/70 hover:text-white transition-colors">
                <Icon name="EnvelopeIcon" size={16} className="text-accent" />
                betalandproperty@gmail.com
              </a>
              <div className="flex items-start gap-2 text-white/70">
                <Icon name="MapPinIcon" size={16} className="text-primary mt-0.5 flex-shrink-0" />
                <span>Sumengko, Sragen Tengah, Kec. Sragen, Kabupaten Sragen, Jawa Tengah 57211</span>
              </div>
            </div>
          </div>

          {/* Nav Groups */}
          {navGroups?.map((group) => (
            <div key={group?.title}>
              <h4 className="font-bold text-white text-sm mb-4 uppercase tracking-wider">{group?.title}</h4>
              <ul className="space-y-2.5">
                {group?.links?.map((link) => (
                  <li key={link?.href}>
                    <Link href={link?.href} className="text-sm text-white/60 hover:text-white transition-colors">
                      {link?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">© 2024 BETALAND.ID. Semua hak dilindungi.</p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-white/40">Property Sales Platform</span>
            <a href="https://wa.me/6281282760110" target="_blank" rel="noopener noreferrer"
              className="flex items-center gap-1.5 px-3 py-1.5 bg-[#25D366]/20 text-[#25D366] text-xs font-semibold rounded-full hover:bg-[#25D366]/30 transition-colors">
              <Icon name="ChatBubbleLeftRightIcon" size={12} /> WhatsApp
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
